import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import AsistenciasMain from '../../Components/Admin/AsistenciasMain/AsistenciasMain'
import EmpleadosMain from '../../Components/Admin/EmpleadosMain/EmpleadosMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import InfoUserMain from '../../Components/Admin/InfoUserMain/InfoUserMain'
export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <EmpleadosMain />
                    </div>
                    <div className='deFLexMain'>
                        <AsistenciasMain />
                        <InfoUserMain />
                    </div>


                </div>
            </section>
        </div>
    )
}
